import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../sidebar/Sidebar';
import StylingAssistant from '../common/StylingAssistant';
import { StylingAssistantProvider } from '../../context/StylingAssistantContext';

/**
 * MainLayout Component
 * 
 * Persistent layout with sidebar on the left and content area on the right.
 * The video background only affects the content area (right side).
 * All future pages will render in the content area while keeping the sidebar constant.
 * 
 * Wrapped in StylingAssistantProvider so both the floating popup and the
 * full-page Style Assistant share the same chat state for seamless
 * expand/collapse transitions.
 */
const MainLayout: React.FC = () => {
  return (
    <StylingAssistantProvider>
      <div className="flex h-screen bg-black overflow-hidden">
        {/* Persistent Sidebar - Always visible */}
        <Sidebar />
        
        {/* Content Area - Right side with video background */}
        <main className="flex-1 overflow-auto relative">
          {/* Video Background - Only on content area */}
          <div className="fixed inset-0 left-[78px] w-full h-full overflow-hidden pointer-events-none z-0">
            <video
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover opacity-50"
              style={{ filter: 'blur(2px)' }}
            >
              <source
                src="https://static.vecteezy.com/system/resources/previews/036/019/611/mp4/abstract-plexus-connecting-dots-and-lines-network-web-animation-abstract-geometric-polygon-animation-on-black-background-abstract-digital-technology-background-free-video.mp4"
                type="video/mp4"
              />
            </video>
            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80" />
          </div>

          {/* Content Wrapper - All pages render here */}
          <div className="relative z-10 px-6 py-2 lg:p-8">
            <Outlet />
          </div>
        </main>

        {/* Floating Chat Bubble — appears on every page except /style-assistant */}
        <StylingAssistant />
      </div>
    </StylingAssistantProvider>
  );
};

export default MainLayout;
